import React from 'react';
import PropTypes from 'prop-types';
import { Search, SearchReverse } from 'components/SvgIcons';
import Button from '../Button';
import './styles.scss';

const ButtonSearch = ({ classNames = [], children, reverse, ...props }) => {
    if (reverse) {
        classNames.push('btn-reverse');
    }
    return (
        <Button {...props} classNames={['custom-btn-search', ...classNames]}>
            {!reverse && (
                <i>
                    <Search />
                </i>
            )}
            <span className="custom-btn-search__text">{children}</span>
            {reverse && (
                <i className="float-right">
                    <SearchReverse />
                </i>
            )}
        </Button>
    );
};

ButtonSearch.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    reverse: PropTypes.bool,
};

export default ButtonSearch;
